import { ModuleWithProviders, NgModule } from '@angular/core';

import {
  NbThemeModule,
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbButtonModule,
  NbButtonGroupModule,
  NbSelectModule,
  NbIconModule,
  NbDatepickerModule,
  NbDialogModule,
  NbWindowModule,
  NbToastrModule,
  NbTreeGridModule,
  NbCardModule,
  NbTabsetModule,
  NbToggleModule,
  NbInputModule,
  NbCheckboxModule,
  NbAutocompleteModule,
  NbListModule,
  NbAccordionModule,
  NbSpinnerModule,
  NbProgressBarModule,
  NbStepperModule,
  NbChatModule,
  NbRadioModule,
  NbTooltipModule
} from '@nebular/theme';

import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbMomentDateModule } from '@nebular/moment';
import { Angular2SmartTableModule } from 'angular2-smart-table';

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbButtonModule,
  NbButtonGroupModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
  NbLayoutModule,
  NbDatepickerModule,
  NbDialogModule,
  NbWindowModule,
  NbToastrModule,
  NbTreeGridModule,
  NbCardModule,
  NbTabsetModule,
  NbToggleModule,
  NbInputModule,
  NbRadioModule,
  NbCheckboxModule,
  NbAutocompleteModule,
  NbMomentDateModule,
  NbAccordionModule,
  NbListModule,
  NbProgressBarModule,
  NbStepperModule,
  NbChatModule,
  NbSpinnerModule,
  NbTooltipModule
];

@NgModule({
  declarations: [],
  imports: [
    // NbThemeModule.forRoot(),
    ...NB_MODULES,
    Angular2SmartTableModule,
    NbMenuModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot()
  ],
  exports: [
    ...NB_MODULES,
    Angular2SmartTableModule
  ]
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers:
        NbThemeModule.forRoot(
          {
            name: 'default',
          },
        ).providers,
    };
  }
}
